<template>
  <ValidationProvider :rules="validate || ''" v-slot="v">
    <div class="form-group" :class="{ 'has-warning': v.errors[0] !== '' }">
      <div :class="{ 'form-group row': inline }">
        <div :class="{ 'col-sm-3 mt-1': inline }">
          <label v-if="label" :for="name" class="control-label">
            {{ label }}:
            <span class="text-danger" v-if="hasAsterisk">*</span>
          </label>
        </div>
        <div :class="{ 'col-sm-9': inline }">
          <input :id="name" class="form-control" :class="addClass" :type="type || 'text'" :name="name" :value="value"
            :min="min" :max="max" :step="step" @input="change" @keyup="keyup" @blur="blur" @change="change"
            :maxlength="maxlength || 200" :placeholder="placeholder || label" :disabled="disabled" :readonly="readonly"
            :tabindex="tabindex" />
        </div>
        <small class="text-danger" v-if="v.errors[0] !== ''">
          {{ v.errors[0] }}
        </small>
      </div>
    </div>
  </ValidationProvider>
</template>
<script>
export default {
  name: 'dt-input',
  props: {
    name: String,
    type: String,
    value: [Number, String, Boolean],
    label: String,
    validate: String,
    disabled: Boolean,
    maxlength: Number,
    placeholder: String,
    autocomplete: String,
    min: String,
    max: String,
    step: String,
    addClass: String,
    readonly: Boolean,
    inline: {
      type: Boolean,
      default: false
    },
    tabindex: [Number, String]
  },
  computed: {
    hasAsterisk() {
      return this.validate && this.validate.includes('required')
    }
  },
  methods: {
    change($event) {
      this.$emit('input', $event.target.value)
      this.$emit('change', $event.target.value)
    },
    keyup($event) {
      this.$emit('keyup', $event.target.value)
    },
    blur($event) {
      this.$emit('blur', $event.target.value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/utilities/form/dt-input.vue